import BaseInputTimePickerList from "./BaseInputTimePickerList.vue";

export default BaseInputTimePickerList;
